__turbopack_context__.v({
  "fallback": "WindowRenderer-module__1MhIlG__fallback",
  "fallbackDocsLink": "WindowRenderer-module__1MhIlG__fallbackDocsLink",
  "fallbackHint": "WindowRenderer-module__1MhIlG__fallbackHint",
  "fallbackMessage": "WindowRenderer-module__1MhIlG__fallbackMessage",
  "fallbackTitle": "WindowRenderer-module__1MhIlG__fallbackTitle",
  "generic": "WindowRenderer-module__1MhIlG__generic",
  "heading": "WindowRenderer-module__1MhIlG__heading",
  "langBtn": "WindowRenderer-module__1MhIlG__langBtn",
  "langSwitcher": "WindowRenderer-module__1MhIlG__langSwitcher",
  "lead": "WindowRenderer-module__1MhIlG__lead",
  "menuList": "WindowRenderer-module__1MhIlG__menuList",
  "newsItem": "WindowRenderer-module__1MhIlG__newsItem",
  "newsList": "WindowRenderer-module__1MhIlG__newsList",
  "newsletterBtn": "WindowRenderer-module__1MhIlG__newsletterBtn",
  "newsletterForm": "WindowRenderer-module__1MhIlG__newsletterForm",
  "newsletterInput": "WindowRenderer-module__1MhIlG__newsletterInput",
  "root": "WindowRenderer-module__1MhIlG__root",
  "search": "WindowRenderer-module__1MhIlG__search",
  "searchIcon": "WindowRenderer-module__1MhIlG__searchIcon",
  "searchInput": "WindowRenderer-module__1MhIlG__searchInput",
  "socialIcon": "WindowRenderer-module__1MhIlG__socialIcon",
  "socialIcons": "WindowRenderer-module__1MhIlG__socialIcons",
});
